import { MantineProvider } from "@mantine/core"
import "@mantine/core/styles.css"
import { DatesProvider } from "@mantine/dates"
import "@mantine/dates/styles.css"
import "@mantine/dropzone/styles.css"
import { Notifications } from "@mantine/notifications"
import "@mantine/notifications/styles.css"
import { NavigationProgress } from "@mantine/nprogress"
import "@mantine/nprogress/styles.css"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { CSSresolver, theme } from "@tfg/themes"
import "@tfg/themes/css/global.css"
import "dayjs/locale/en"
import "dayjs/locale/fr"
import i18n from "i18next"
import { RouterProvider } from "react-router-dom"

import { AxiosErrorHandler } from "~/backend/AxiosErrorHandler.tsx"
import { queryClient } from "~/backend/queryClient.ts"
import { router } from "~/pages/router.tsx"
import { AuthContextProvider } from "~/store/auth-context.tsx"

function App() {
  return (
    <MantineProvider theme={theme} cssVariablesResolver={CSSresolver}>
      <Notifications position="top-right" />
      <NavigationProgress color="green.2" />
      <DatesProvider settings={{ locale: i18n.language }}>
        <AuthContextProvider>
          <AxiosErrorHandler>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </AxiosErrorHandler>
        </AuthContextProvider>
      </DatesProvider>
    </MantineProvider>
  )
}

export default App
